'use strict';


import videojs from 'video.js'
import './videoplayer-analytics';
import {AnalyticsPlayer, analyticsModeGoogleTags} from './videoplayer-analytics.js';

document.querySelectorAll('.inline-embed').forEach(inline => enableVideo(inline));

function enableVideo(element: Element) {
    const
        videoEl = element.querySelector('video')!,
        options = videoOptions(true, videoEl.dataset.autoplay == "true");

    if (element.classList.contains('autoplay-inview')) {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    videojs.getPlayer(entry.target.children[0].id).autoplay(false);
                    console.debug('no autoplay for', element);
                }
                observer.unobserve(entry.target);
            });
        });

        observer.observe(element);
    }

    
    const player = videojs(videoEl, options) as AnalyticsPlayer;

    window.gtag = window.gtag || console.log;

    player.analytics({
      events: [
        { action: "play" },
        { action: "pause" },
        { action: "ended" },
        { name: "fullscreenchange", action: "fullscreen change" },
        { name: "volumechange", action: "volume changed" },
        { action: "resize" },
        { action: "error" },
        { name: "resolutionchange", action: "resolution change" },
        { name: "timeupdate", action: "time updated" },
      ],
      assetName: player.currentSrc(),
      mode: analyticsModeGoogleTags,
    });

    player.ready(function () {
        if (videoEl.dataset.src) {
            player.src({
                src: videoEl.dataset.src,
                type: videoEl.dataset["src-type"],
            });
        }
    });

    document.querySelectorAll("a.video-time-link").forEach(link => {
        const vtLink = link as HTMLAnchorElement
        vtLink.onclick = (_e) => {
            player.currentTime(parseFloat(vtLink.dataset.time||"0"))
            player.play()
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
    })
}

function videoOptions(controls:boolean,autoplay:boolean) {
    const
        is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
        ua = navigator.userAgent.toLowerCase(),
        isAndroid = ua.indexOf("android") > -1;

    let videoOptions:any = {
        controls: false,
        nativeControlsForTouch: is_safari,
        autoplay: true,
        html5: {
            nativeAudioTracks: is_safari,
            nativeVideoTracks: is_safari,
            vhs: {
                withCredentials: false
                // overrideNative: !is_safari,
            },
        },
    };

    if (isAndroid) {
        videoOptions = {
            controls: false,
            nativeControlsForTouch: false,
            autoplay: true,
            html5: {
                nativeAudioTracks: false,
                nativeVideoTracks: false,
                vhs: {
                    overrideNative: true,
                },
            },
        };
    }

    videoOptions.controls = controls
    videoOptions.autoplay = autoplay

    return videoOptions;
}